import {
	Dialog,
	DialogBackdrop,
	Transition,
	TransitionChild,
} from "@headlessui/react";
import React, { FC, Fragment, useEffect, useState } from "react";
import ButtonPrimary from "shared/Button/ButtonPrimary";
import ButtonClose from "shared/ButtonClose/ButtonClose";
import dayjs from "dayjs";

import "dayjs/locale/fr";
import { SelectHours } from "./SelectHours";
import { PlusIcon, XCircleIcon } from "@heroicons/react/24/solid";
import ButtonSecondary from "shared/Button/ButtonSecondary";
import Select from "shared/Select/Select";
import { DAY_OFF_TYPES } from "contains/contants";
import Input from "shared/Input/Input";
dayjs.locale("fr");
export interface ModalUpdateDayProps {
	show: boolean;
	timeSlots?: [];
	day: any;
	onConfirm: (day: any) => void;
	onCloseModal: () => void;
}

const ModalUpdateDay: FC<ModalUpdateDayProps> = ({
	day,
	onConfirm,
	show,
	onCloseModal,
}) => {
	const [modifiedTimeSlots, setModifiedTimeSlots] = useState<any>([
		...(day.timeSlots || []),
	]);
	const [dayOffType, setDayOffType] = useState<any>(day.dayOffType || "");
	const [isRemoteWorking, setIsRemoteWorking] = useState<any>(
		day.isRemoteWorking || false
	);

	useEffect(() => {}, []);

	return (
		<Transition appear show={show} as={Fragment}>
			<Dialog
				as="div"
				className="fixed inset-0 z-50"
				onClose={() => {
					onCloseModal();
				}}
			>
				<div className="flex items-stretch md:items-center justify-center h-full text-center md:px-4">
					<TransitionChild
						as={Fragment}
						enter="ease-out duration-300"
						enterFrom="opacity-0"
						enterTo="opacity-100"
						leave="ease-in duration-200"
						leaveFrom="opacity-100"
						leaveTo="opacity-0"
					>
						<DialogBackdrop className="fixed inset-0 bg-black/40 dark:bg-black/70" />
					</TransitionChild>

					{/* This element is to trick the browser into centering the modal contents. */}
					<span className="inline-block align-middle" aria-hidden="true">
						&#8203;
					</span>
					<TransitionChild
						as={Fragment}
						enter="ease-out duration-300"
						enterFrom="opacity-0 scale-95"
						enterTo="opacity-100 scale-100"
						leave="ease-in duration-200"
						leaveFrom="opacity-100 scale-100"
						leaveTo="opacity-0 scale-95"
					>
						<div className="relative inline-flex xl:py-8 xs:w-full max-h-full w-[400px]">
							<div
								className="flex-1 flex overflow-hidden max-h-full p-8 w-full text-left align-middle transition-all transform lg:rounded-2xl bg-white 
				  dark:bg-neutral-900 dark:border dark:border-slate-700 dark:text-slate-100 shadow-xl max-h-[500px]"
							>
								<span className="absolute right-3 top-3 z-50">
									<ButtonClose onClick={onCloseModal} />
								</span>

								<div className="flex-1 overflow-y-auto rounded-xl hiddenScrollbar text-center">
									<p className="text-sm">Modification horaires</p>
									<h3 className="text-xl font-semibold">
										{dayjs(day.dayDate).format("dddd DD MMMM YYYY")}
									</h3>

									<div className="flex flex-col items-center mt-5">
										{modifiedTimeSlots.map((t: any, indexT: number) => {
											return (
												<div
													className="flex flex-row items-center gap-1"
													key={indexT}
												>
													<SelectHours
														minuteStep={5}
														className={""}
														value={t.fromHour}
														onChange={({ target }: { target: any }) => {
															modifiedTimeSlots[indexT].fromHour = target.value;
															setModifiedTimeSlots([...modifiedTimeSlots]);
														}}
													/>{" "}
													-
													<SelectHours
														className={""}
														value={t.toHour}
														onChange={({ target }: { target: any }) => {
															modifiedTimeSlots[indexT].toHour = target.value;
															setModifiedTimeSlots([...modifiedTimeSlots]);
														}}
													/>
													<XCircleIcon
														className="w-20 h-14 mr-0 cursor-pointer"
														aria-hidden="true"
														onClick={() => {
															modifiedTimeSlots.splice(indexT, 1);
															setModifiedTimeSlots([...modifiedTimeSlots]);
														}}
													/>
												</div>
											);
										})}
										<ButtonSecondary
											onClick={() => {
												modifiedTimeSlots.push({
													fromHour: "",
													toHour: "",
												});
												setModifiedTimeSlots([...modifiedTimeSlots]);
											}}
											className="!bg-slate-100 hover:!bg-slate-200 mt-3 !py-2 !px-3 !rounded-[10px]"
										>
											<PlusIcon className="w-4 h-4 mr-0" aria-hidden="true" />
											Ajouter
										</ButtonSecondary>
									</div>

									{modifiedTimeSlots.length > 0 && (
										<div className="flex flex-row justify-center items-center mt-5">
											<p className="text-sm font-bold mr-2">Télétravail :</p>

											<Input
												type="checkbox"
												className={
													"!w-[20px] !h-[20px] !p-0 !rounded-md !border-slate-900"
												}
												checked={isRemoteWorking}
												value={isRemoteWorking}
												onChange={({ target }: { target: any }) => {
													setIsRemoteWorking(target.checked);
												}}
											/>
										</div>
									)}

									{modifiedTimeSlots.length === 0 && (
										<div className="flex flex-col items-center mt-5">
											<p className="text-sm font-bold">Motif absence :</p>

											<Select
												className={""}
												value={dayOffType}
												onChange={({ target }: { target: any }) => {
													setDayOffType(target.value);
												}}
											>
												<option value=""></option>
												{DAY_OFF_TYPES.map((dayOff, index: number) => (
													<option value={dayOff}>{dayOff}</option>
												))}
											</Select>
										</div>
									)}

									<div className="flex flex-col sm:flex-row pt-6 items-center justify-center">
										<ButtonPrimary
											className="!py-2 !px-4 rounded-xl shadow-none"
											onClick={() => {
												// send();
												const nDay = {
													...day,
													timeSlots: modifiedTimeSlots,
													dayOffType,
													isRemoteWorking,
												};
												onConfirm(nDay);
											}}
										>
											Valider
										</ButtonPrimary>
									</div>
								</div>
							</div>
						</div>
					</TransitionChild>
				</div>
			</Dialog>
		</Transition>
	);
};

export default ModalUpdateDay;
